import { Action } from '@ngrx/store';
import { Group } from '../../shared/models/groups/groups.model';
import { ValidationResponseModel } from '../../shared/models/validation-response.model';
import { CrsXMLResponseModel } from '../../shared/models/crx-xml-response.model';

export const VALIDATE_SUCCESS = '[XENA] VALIDATE_SUCCESS';
export const VALIDATE = '[XENA] VALIDATE';
export const VALIDATE_ERROR = '[XENA] VALIDATE_ERROR';
export const CANCEL_VALIDATIONS = '[XENA] CANCEL_VALIDATIONS';
export const GET_CRS_XML = '[XENA] GET_CRS_XML';
export const GET_CRS_XML_SUCCESS = '[XENA] GET_CRS_XML_SUCCESS';
export const GET_CRS_XML_ERROR = '[XENA] GET_CRS_XML_ERROR';
export const SEND_XML_TO_CRS = '[XENA] SEND_XML_TO_CRS';

export const SEND_TO_URLAUBSIDEE = '[XENA] SEND_TO_URLAUBSIDEE';

export class ValidateSuccess implements Action {
	readonly type = VALIDATE_SUCCESS;

	constructor(public payload: ValidationResponseModel, public offer: Group) {}
}

export class ValidateError implements Action {
	readonly type = VALIDATE_ERROR;

	constructor(public id: string, public message?: string) {}
}

export class Validate implements Action {
	readonly type = VALIDATE;

	constructor(public payload: Group, public childrenAges?: string) {}
}

export class CancelValidations implements Action {
	readonly type = CANCEL_VALIDATIONS;

	constructor() {}
}

export class GetCrsXml implements Action {
	readonly type = GET_CRS_XML;

	constructor(public payload: ValidationResponseModel) {}
}

export class GetCrsXmlSuccess implements Action {
	readonly type = GET_CRS_XML_SUCCESS;

	constructor(public payload: CrsXMLResponseModel, public id: string) {}
}

export class GetCrsXmlError implements Action {
	readonly type = GET_CRS_XML_ERROR;

	constructor(public message?: string) {}
}

export class SendXmlToCrs implements Action {
	readonly type = SEND_XML_TO_CRS;

	constructor(public message?: string) {}
}

export class SendToUrlaubsIdee implements Action {
	readonly type = SEND_TO_URLAUBSIDEE;

	constructor(public data: {offer: Group, validate: ValidationResponseModel, xml: string}) {}

}

export type All
	= ValidateSuccess
	| ValidateError
	| Validate
	| CancelValidations
	| GetCrsXml
	| GetCrsXmlSuccess
	| GetCrsXmlError
	| SendXmlToCrs
	| SendToUrlaubsIdee;



// WEBPACK FOOTER //
// ./src/app/xena/core/state-management/actions/validate.ts